import React from 'react';
import { Routes, Route } from 'react-router-dom';
import withErrorBoundary from './components/common/ErrorBoundary/withErrorBoundary';
import OrganizationFacilityLayout from './layouts/OrganizationFacilityLayout';
import Login from './pages/Login/LoginContainer';
import AcceptInvitation from './pages/AcceptInvitations';
import ResetPassword from './pages/ResetPassword';
import Unit from './pages/UnitContainerPage';
import UsageHistory from './pages/dataVisualizationViews/UsageHistory';
import RealTimeLocation from './pages/dataVisualizationViews/RealTimeLocation';
import WaterChanges from './pages/dataVisualizationViews/WaterChanges';
import FilterLife from './pages/dataVisualizationViews/FilterLife';
import BatteryLife from './pages/dataVisualizationViews/BatteryLife';
import UserManagement from './pages/UserManagement';
import BeaconLocation from './pages/Beacon&Location';
import NotFoundHandler from './components/common/NotFoundHandler';
import OrganizationCreate from './pages/OrganizationCreate';
import { DashboardPage as OrganizationConfiguration } from './pages/OrganizationConfiguration';
import SetOrganizationStructurePage from './pages/SetOrganizationStructurePage';
import { InviteUsersPage } from './pages/InviteUsersPage';
import { SetCleaningStandardsPage } from './pages/SetCleaningStandardsPage';
import ProtectedRoutes from './components/common/ProtectedRoutes';
import { CreateOrganizationPage } from './pages/CreateOrganization';
import { DashboardPage } from './pages/Dashboard';
import { FeatureFlagsPage } from './pages/FeatureFlagsPage';
import Summary from './pages/Summary';
import { useScrollToTopOnReload } from './hooks';

const WrappedLogin = withErrorBoundary(Login);
const WrappedAcceptInvitation = withErrorBoundary(AcceptInvitation);
const WrappedResetPassword = withErrorBoundary(ResetPassword);
const WrappedUnit = withErrorBoundary(Unit);
const WrappedUsageHistory = withErrorBoundary(UsageHistory);
const WrappedRealTimeLocation = withErrorBoundary(RealTimeLocation);
const WrappedWaterChanges = withErrorBoundary(WaterChanges);
const WrappedFilterLife = withErrorBoundary(FilterLife);
const WrappedBatteryLife = withErrorBoundary(BatteryLife);
const WrappedUserManagement = withErrorBoundary(UserManagement);
const WrappedBeaconLocation = withErrorBoundary(BeaconLocation);
const WrappedOrganizationCreate = withErrorBoundary(OrganizationCreate);
const WrappedOrganizationConfiguration = withErrorBoundary(OrganizationConfiguration);
const WrappedSetOrganizationStructure = withErrorBoundary(SetOrganizationStructurePage);
const WrappedInviteUsers = withErrorBoundary(InviteUsersPage);
const WrappedSetCleaningStandards = withErrorBoundary(SetCleaningStandardsPage);
const WrappedCreateOrganization = withErrorBoundary(CreateOrganizationPage);
const WrappedDashboard = withErrorBoundary(DashboardPage);
const WrappedSummary = withErrorBoundary(Summary);

const AppRoutes = () => {
  useScrollToTopOnReload();

  return (
    <Routes>
      {/* Public routes */}
      <Route key="login" path="/" element={<WrappedLogin />} />
      <Route key="reset-password" path="/reset-password" element={<WrappedResetPassword />} />

      <Route
        key="accept-invitation"
        path="/accept-invitation"
        element={<WrappedAcceptInvitation />}
      />
      <Route key="feature-flags" path="/feature-flags" element={<FeatureFlagsPage />} />

      {/* Protected routes */}
      <Route key="protected" element={<ProtectedRoutes />}>
        <Route
          key="create-organization"
          path="/create-organization"
          element={<WrappedCreateOrganization />}
        />
        <Route key="dashboard" path="/dashboard" element={<WrappedDashboard />} />
        <Route key="facility-selection" path="/facility-selection" element={<WrappedSummary />} />
        <Route key="unit" path="/unit" element={<WrappedUnit />} />
        <Route key="battery" path="/battery" element={<WrappedBatteryLife />} />
        <Route key="usage" path="/usage" element={<WrappedUsageHistory />} />
        <Route key="location" path="/location" element={<WrappedRealTimeLocation />} />
        <Route key="waterChanges" path="/waterChanges" element={<WrappedWaterChanges />} />
        <Route key="filter" path="/filter" element={<WrappedFilterLife />} />
        <Route
          key="organization-create"
          path="/organization/create"
          element={<WrappedOrganizationCreate />}
        />
        <Route
          key="organization-configuration"
          path="/organization/configuration"
          element={<WrappedOrganizationConfiguration />}
        />
        <Route
          key="organization-structure"
          path="/organization/structure"
          element={<WrappedSetOrganizationStructure />}
        />
        <Route
          key="organization-invite-users"
          path="/organization/invite-users"
          element={<WrappedInviteUsers />}
        />
        <Route
          key="set-cleaning-standards"
          path="/organization/set-cleaning-standards"
          element={<WrappedSetCleaningStandards />}
        />
        <Route key="organization-facility" element={<OrganizationFacilityLayout />}>
          <Route
            key="user-management"
            path="/user-management"
            element={<WrappedUserManagement />}
          />
        </Route>
        <Route key="beacon-location" path="/beacon-location" element={<WrappedBeaconLocation />} />
      </Route>
      <Route key="not-found" path="*" element={<NotFoundHandler />} />
    </Routes>
  );
};

export default AppRoutes;
